import SEND_EMAIL from '@/graphql/mutations/email/sendEmail.gql';

export default {
  methods: {
    async mixSendEmail(body) {
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: SEND_EMAIL,
          variables: {
            body,
          },
        }).then(() => {
          this.mixMensajeSuccess('Email enviado correctamente');
        })
        .catch((error) => {
          this.mixMensajeError(error);
        })
        .finally(() => {
          this.mixEsCargando();
        });
    },
  },
};
